export enum ProductType {
  Analytics = 'analytics_product',
  Feedback = 'feedback_product',
}

export type ToolName =
  | 'Dashboard'
  | 'Heatmaps'
  | 'Highlights'
  | 'Feedback'
  | 'Recordings'
  | 'Surveys'
  | 'Trends'
  | 'Funnels';
